import {Component, HostListener} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from "./Services/AuthGard.service";
import {Observable} from "rxjs/Observable";
import {GlobalService} from "./Services/global.service";
import {UserService} from "./Services/Users.service";
import {ActivatedRoute, Router} from "@angular/router";
import { CookieService } from 'ngx-cookie-service';
import Bugsnag from '@bugsnag/js';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';

declare var Tour: any;
declare var $;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  langList: any;
  data:any;
  lang_name:any;
  lang_id:any;
  isLoggedIn$ = Observable.of(false);
  tourTranslateData : any;
  tour: any;
  communityLogoShow: boolean = false;
  community_name : string = '';
  cognitoCode: any;
  cognitoURL : boolean;
  currentURL: string;
  activateLink: boolean;
  constructor(private authService: AuthService, private translate: TranslateService,
      private userService : UserService, private globalService : GlobalService, 
      private route : Router,private actroute: ActivatedRoute, private cookieService: CookieService,
      private router:  ActivatedRoute) {
      Bugsnag.start({ apiKey: '997e39528967efd2a88d8f8f18a3c91a' })
    let defaultLangData;
    console.log("cookie get data",this.cookieService.get('defaultLangData'));
    let customObject1 = {
      lang_id : this.lang_id,
      lang_name:this.lang_name
    };
    try {
      defaultLangData = JSON.parse(this.cookieService.get('defaultLangData'))?JSON.parse(this.cookieService.get('defaultLangData')):customObject1;
    } catch(exp){
      console.log(exp)
    }
    console.log("------------------- Cookie Lang-----------------------");
    console.log(defaultLangData);
    
    if(defaultLangData){
      // alert(defaultLangData.lang_name);
      this.lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : "English";
      this.lang_id = defaultLangData.lang_id ? defaultLangData.lang_id : "English";
    } else {
      this.lang_name = "English";
      this.lang_id = "English";
    }
  
    this.globalService.setLang(this.lang_name);
    this.globalService.setLangId(this.lang_id);

    localStorage.setItem('defaultLangId', this.lang_id);
    localStorage.setItem('defaultLang', this.lang_name);

    translate.reloadLang(this.lang_name);

    let customObject = {
      lang_id : this.lang_id,
      lang_name:this.lang_name
    };
    let jsonString = JSON.stringify(customObject);
    this.cookieService.set('defaultLangData',  jsonString, 365,'/');
    console.log("------------------- After Lang Set -----------------------");
    console.log(document.cookie);

    this.userService.getLang().subscribe(lang => {
      if (lang.success) {
        this.langList = lang.data;
      }
    });
  }

  @HostListener('document:keyup', ['$event'])
  @HostListener('document:click', ['$event'])
  @HostListener('document:wheel', ['$event'])
  resetTimer() {
    this.authService.notifyUserAction();
  }

  ngOnInit() {
    // alert(window.location.href);
    if (window.location.href.indexOf('?')!=-1) {
      // alert("contains params")
      this.activateLink = false;
      //do your stuff. example: console.log('id: ', this.route.snapshot.queryParams['id']);
 }else{
      // alert("not contains params")
      this.activateLink = true;
    }
    // alert(this.activateLink);
    // this.currentURL = window.location.href;
    // console.log("queryParams",this.actroute.snapshot.queryParams);
    this.isLoggedIn$ = this.authService.isUserLoggedIn;
    console.log("--------------isLoggedIn$-----------------");
    console.log(this.isLoggedIn$);
    console.log(this.authService.getToken());
    document.addEventListener("Show Header On Login", (e) =>{
      this.isLoggedIn$ = this.authService.isUserLoggedIn;
      console.log("is user logged in",this.authService.isUserLoggedIn)
    });

    this.translate.get(['TOUR_PREV', 'TOUR_NEXT', 'TOUR_END', 'MENU.LEARN', 'MENU.SCORECARD', 'MENU.TENDENCY', 'MENU.LEADER_BOARD', 'SETTING', 'MENU.SUBSCRIPTION', 'UPDATE_PROFILE', 'HELP', 'LOGOUT', "MENU.LEADER_BOARD", "CHANGE_PWD",'SECURITY_QUE', 'NOTIFICATION.NOTIFICATION']).subscribe(label =>{
      this.tourTranslateData = label;
    });
    this.globalService.getTranslationTourHome();
  }

  selectName(){
    // alert("global lang select");
    let lang = this.langList.find(lang => lang.lang_name == this.lang_name);
    this.lang_id = lang ? lang.language_id : "English";

    console.log("------------------- Before Lang Set -----------------------");
    console.log(this.lang_name);
    console.log(this.lang_id);
    let customObject = {
      lang_id : this.lang_id,
      lang_name:this.lang_name
    };
    let jsonString = JSON.stringify(customObject);
    this.cookieService.set('defaultLangData',  jsonString, 365,'/');
    console.log("------------------- After Lang Set -----------------------");
    console.log(document.cookie);
    window.location.reload();
  }

  startHomeTour(event){
    if(event.detail < 2){
      let currentScreen = "LOGIN_PAGE";
      // this.globalService.getTranslationTourHome();
      let stepArr = this.globalService.getRespectiveTourData(currentScreen);
      this.tour = new Tour({
        debug: true,
        storage: false,
        backdrop: true,
        orphan : false,
        steps : stepArr,
        template :  "<div class='popover tour'>" +
        "<div class='arrow'></div>" +
        "<h3 class='popover-title'></h3>" +
        "<div class='popover-content'></div>" +
        "<div class='popover-navigation'>" +
        "<div class='btn-group'><button class='btn btn-sm btn-default' data-role='prev'>« "+ this.tourTranslateData.TOUR_PREV+"</button>" +
        "<button class='btn btn-sm btn-default' data-role='next'>"+ this.tourTranslateData.TOUR_NEXT+" »</button></div>" +
        "<button class='btn btn-sm btn-default endTour' data-role='end'>"+ this.tourTranslateData.TOUR_END+"</button></div></div>"
        /*onEnd: function (tour) {
         theUser.user.newUser = '';
         localStorage.setItem('currentUser', JSON.stringify(theUser));
         }*/
      });
      // Initialize the tour
      this.tour.init();
      this.tour.start(true);
    }
  }

  showLogo(){
    if(this.globalService.isLoginComm.communityID  != null  && this.globalService.isLoginComm != null){
      this.communityLogoShow = false; // Logo disabled
      this.community_name = this.globalService.isLoginComm.communityName;
      // $("#complogoImg").attr('src', "data:image/png;base64, " + this.globalService.isLoginComm.image_data);
      return false;
    }else{
      this.communityLogoShow = false;
      this.community_name = '';
      return true;
    }
  }

  gotoLoginPage(){
    // if (!this.cognitoURL) {
    //   event.preventDefault();
    // }
    if(this.globalService.isLoginComm.communityID != null){
      let obj = {communityID : this.globalService.isLoginComm.communityID};
      let str = '/login/'+ window.btoa(JSON.stringify(obj));
      // alert(str);
      let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
      this.translate.reloadLang(lang_name);
      this.route.navigate([str]);
    }else{
      let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
      this.translate.reloadLang(lang_name);
      this.route.navigate(['/login']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts